export default __webpack_public_path__ + "static/media/DiffusionImg.8cec269e.jpg";